import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarFour: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M10.7865 16.8442C11.3346 16.8442 11.779 17.2816 11.779 17.8213V18.5052C11.779 19.0449 12.2233 19.4823 12.7715 19.4823L17.5559 19.4824C18.1041 19.4824 18.5484 19.0449 18.5484 18.5052V17.7236C18.5484 17.1839 18.1041 16.7465 17.5559 16.7465L12.7715 16.7465C12.2233 16.7465 11.779 16.309 11.779 15.7694V10.7592H9V15.8671C9 16.4067 9.44435 16.8442 9.99249 16.8442H10.7865Z"
      fill={color}
    />
    <path
      d="M11.779 15.7694L9 15.7694V9.63724C9 9.0976 9.44435 8.66016 9.99249 8.66016H10.7865C11.3346 8.66016 11.779 8.22268 11.779 7.68305V6.99908C11.779 6.45944 12.2233 6.02197 12.7715 6.02197L17.5559 6.02198C18.1041 6.02198 18.5484 6.45944 18.5484 6.99909V7.78077C18.5484 8.3204 18.1041 8.75786 17.5559 8.75786L12.7715 8.75785C12.2233 8.75785 11.779 9.19531 11.779 9.73496V15.7694Z"
      fill={color}
    />
    <path
      d="M21.2135 16.8442C20.6654 16.8442 20.221 17.2816 20.221 17.8213V18.5052C20.221 19.0449 19.7767 19.4824 19.2285 19.4824L14.4441 19.4823C13.8959 19.4823 13.4516 19.0449 13.4516 18.5052V17.7236C13.4516 17.1839 13.8959 16.7465 14.4441 16.7465L16.8363 16.7465L19.2285 16.7465C19.7767 16.7465 20.221 16.309 20.221 15.7694V10.7592H23V15.8671C23 16.4067 22.5556 16.8442 22.0075 16.8442H21.2135Z"
      fill={color}
    />
    <path
      d="M20.221 15.7694L23 15.7694V9.63724C23 9.0976 22.5556 8.66016 22.0075 8.66016H21.2135C20.6654 8.66016 20.221 8.22269 20.221 7.68306V6.99909C20.221 6.45944 19.7767 6.02198 19.2285 6.02198L14.4441 6.02197C13.8959 6.02197 13.4516 6.45944 13.4516 6.99908V7.78076C13.4516 8.32039 13.8959 8.75785 14.4441 8.75785L19.2285 8.75786C19.7767 8.75786 20.221 9.19532 20.221 9.73496V15.7694Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8544 11.5834C12.8544 12.1189 13.3022 12.553 13.8545 12.553H14.6546C15.207 12.553 15.6548 12.1189 15.6548 11.5834V10.7592C15.6548 10.2237 15.207 9.78958 14.6546 9.78958H13.8545C13.3022 9.78958 12.8544 10.2237 12.8544 10.7592V11.5834Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5402 11.5834C16.5402 12.1189 16.988 12.553 17.5404 12.553H18.3405C18.8928 12.553 19.3406 12.1189 19.3406 11.5834V10.7592C19.3406 10.2237 18.8928 9.78958 18.3405 9.78958H17.5404C16.988 9.78958 16.5402 10.2237 16.5402 10.7592V11.5834Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0922 15.0365C13.0922 15.5721 13.54 16.0062 14.0923 16.0062L17.9076 16.0062C18.46 16.0062 18.9078 15.572 18.9078 15.0365V14.2123C18.9078 13.6768 18.46 13.2427 17.9076 13.2427L14.0923 13.2427C13.54 13.2427 13.0922 13.6769 13.0922 14.2124V15.0365Z"
      fill={color}
    />
    <path
      d="M12.548 18.5591C12.548 19.0947 12.1002 19.5288 11.5478 19.5288H10.8477C10.2954 19.5288 9.8476 19.9629 9.8476 20.4984L9.84759 25.0523C9.84759 25.5879 10.2954 26.022 10.8477 26.022H11.6479C12.2002 26.022 12.648 25.5879 12.648 25.0523L12.648 20.4984C12.648 19.9629 13.0958 19.5288 13.6481 19.5288H18.703V16.8138H13.5481C12.9957 16.8138 12.548 17.2479 12.548 17.7834V18.5591Z"
      fill={color}
    />
    <path
      d="M14.2002 19.4614V16.7465H18.0391C18.5914 16.7465 19.0392 17.1806 19.0392 17.7161V18.4918C19.0392 19.0273 19.487 19.4614 20.0393 19.4614H20.7394C21.2918 19.4614 21.7396 19.8956 21.7396 20.4311L21.7396 24.985C21.7396 25.5205 21.2918 25.9546 20.7394 25.9546H19.9393C19.387 25.9546 18.9392 25.5205 18.9392 24.985V20.4311C18.9392 19.8956 18.4914 19.4614 17.9391 19.4614H14.2002Z"
      fill={color}
    />
  </svg>
);

export default AvatarFour;
